<template>
  <div class="modal-crop-image-container">
    <div class="modal-crop-image-content">
      <vue-cropper
        ref="cropper"
        class="cropper-container"
        :output-size="{ width: 1280, height: 960 }"
        :view-mode="1"
        :drag-mode="'move'"
        :rotatable="false"
        :initial-aspect-ratio="1"
        :aspect-ratio="4 / 3"
        :src="fileSrc"
        preview=".preview"
      />
      <div class="preview" />
    </div>
    <div class="actions-CRUD-container">
      <button-main @click="cropImage" :active="true">
        {{ btnText }}
      </button-main>
      <button-main @click="closeWithoutPhoto">
        {{ btnTextClear }}
      </button-main>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
export default {
  name: "ModalCropImg",
  components: { ButtonMain, VueCropper },
  data() {
    return {
      onComplete: () => "",
      btnText: "Обрезать фото",
      btnTextClear: "Не обрезать фото",
      fileSrc: "",
      file: null,
      mainTitle: "Обрезать фотографию",
      buttonName: "Сохранить",
      buttonCropName: "Обрезать",
      showCropper: false,
      croppedImageUrl: "",
      blob: "",
    };
  },
  created() {
    this.setInitialParams(this.isActiveModalName);
  },
  methods: {
    async cropImage() {
      const canvas = this.$refs.cropper.getCroppedCanvas({
        width: 1280,
        height: 720,
      });
      const fileSrc = canvas.toDataURL("image/jpeg", 0.92);
      canvas.toBlob((blob) => {
        if (!blob) {
          this.alertError("Не удалось подготовить изображение");
          return;
        }
        this.onComplete({ file: blob, fileSrc });
        this.MODAL(null);
      }, "image/jpeg", 0.92);
    },
    closeWithoutPhoto() {
      this.onComplete({ file: this.file, fileSrc: this.fileSrc });
      this.MODAL(null);
    },
    setInitialParams(params) {
      let paramsInfo = params.info;
      if (paramsInfo.fileOutSrc) {
        this.fileSrc = paramsInfo.fileOutSrc;
        this.file = paramsInfo.fileOut;
      }
      this.onComplete = params.onComplete;
    },
  },
};
</script>

<style scoped lang="scss">
.modal-crop-image-container {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  align-items: center;
  justify-content: space-between;
  height: fit-content;
  width: 100%;
  .modal-crop-image-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 16px;
    row-gap: 16px;
    @media (max-width: 769px) {
      flex-direction: column;
    }
  }
  .cropper-container {
    overflow: hidden;
    border-radius: 8px;
    width: 250px;
    height: 400px;

    @media (max-width: 769px) {
      height: 250px;
      width: 100%;
    }
  }
  .preview {
    border-radius: 8px;
    overflow: hidden;
    width: 260px;
    height: 160px;
    @media (max-width: 769px) {
    }
  }
  .actions-CRUD-container {
    @media (max-width: 769px) {
      justify-content: center;
    }
  }
}
</style>
